/* eslint-disable no-mixed-spaces-and-tabs */
import type { FormProps } from './types';
import RichText from '@/components/RichText';
import SingleForm from '@/components/SingleForm';
import { cls } from '@/utils/cls';
import style from './Form.module.scss';
export default function Form({
  extendStyles,
  heading = true,
  headingCopy,
  form,
  color,
  showFinePrint,
  finePrint,
  showLogos,
  centered,
  maxWidth,
  backgroundImage,
  backgroundColor
}: FormProps) {
  const _className = cls(style.root, extendStyles, centered ? style.centered : undefined);
  const containerStyle = {
    backgroundColor: heading ? color || '#FFDB00' : 'transparent',
    borderColor: heading ? color || '#FFDB00' : 'transparent',
    borderStyle: heading ? 'solid' : 'none',
    marginTop: heading ? '' : 'var(--space-25)',
    maxWidth: maxWidth ? `${maxWidth}px` : '425px',
    padding: heading ? '' : 'var(--space-15)'
  } as React.CSSProperties;
  const wrapperStyle = {
    backgroundColor: backgroundColor || 'transparent'
  };
  return <div className={style.wrapper} style={wrapperStyle} data-sentry-component="Form" data-sentry-source-file="Form.tsx">
			{backgroundImage?.src && <div className={style.background} role="presentation">
					<img src={backgroundImage.src} alt="" role="presentation" data-placement={backgroundImage.backgroundImagePlacement} />
				</div>}
			<article className={_className} id="form-container" style={containerStyle}>
				{heading && headingCopy && <RichText text={headingCopy} className={style.heading} />}
				<SingleForm form={form} showFinePrint={showFinePrint} finePrint={finePrint} showLogos={showLogos} data-sentry-element="SingleForm" data-sentry-source-file="Form.tsx" />
			</article>
		</div>;
}